import { gql } from '@apollo/client';

export const CREATE_PROJECT_UPLOAD_RESEARCH_RECORD = gql`
  mutation CreateProjectUploadRecord($fileAttributes: UploadFileAttributes!, $projectId: ID!) {
    createProjectUploadRecord(fileAttributes: $fileAttributes, projectId: $projectId) {
      success
    }
  }
`;

export const CREATE_ATTACHMENT = gql`
  mutation CreateAttachment($filename: String!, $projectId: ID!) {
    createAttachment(filename: $filename, projectId: $projectId) {
      success
    }
  }
`;

export const GET_COMPANY_AVAILABLE_STORAGE = gql`
  query Company($id: ID!) {
    company(id: $id) {
      uploadResearchAvailableStorage
    }
  }
`;
